import React from 'react'
import { ConfigProvider } from '@ntuctech/tangram-web'
import tangramNextConfig from '../../lib/tangramNextConfig'

export const TangramFairpriceProvider = ({ children, experimental }) => {
  return (
    <ConfigProvider tokens={tangramNextConfig} experimental={experimental}>
      {children}
    </ConfigProvider>
  )
}
